<template>
  <div>
    <top />
    <search />
    <nav-com />
  </div>
</template>

<script>
import Top from '@/components/top.vue'
import Search from '@/components/search.vue'
import NavCom from '@/components/nav/index.vue'
export default {
  name: 'NavBar',
  components: {
    Top,
    Search,
    NavCom
  }
}
</script>

<style>

</style>